/* youthfulbloom — password gate countdown.

   The section bakes the store's UTC offset into data-target, so every visitor
   counts down to the same instant rather than to their own local clock.

   If the target is unparseable or already past, the whole block is removed
   instead of being left frozen at 00:00:00:00. */

(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function start(el) {
    if (el.dataset.ybPwInit === '1') return;
    el.dataset.ybPwInit = '1';

    var target = Date.parse(el.getAttribute('data-target'));
    if (isNaN(target)) {
      el.remove();
      return;
    }

    var days = el.querySelector('[data-unit="days"]');
    var hours = el.querySelector('[data-unit="hours"]');
    var minutes = el.querySelector('[data-unit="minutes"]');
    var seconds = el.querySelector('[data-unit="seconds"]');
    if (!days || !hours || !minutes || !seconds) return;

    var timer = null;

    function tick() {
      var left = target - Date.now();

      if (left <= 0) {
        if (timer) clearInterval(timer);
        el.remove();
        return;
      }

      var s = Math.floor(left / 1000);
      days.textContent = pad(Math.floor(s / 86400));
      hours.textContent = pad(Math.floor((s % 86400) / 3600));
      minutes.textContent = pad(Math.floor((s % 3600) / 60));
      seconds.textContent = pad(s % 60);
    }

    tick();
    if (el.isConnected) timer = setInterval(tick, 1000);
  }

  function init() {
    var blocks = document.querySelectorAll('[data-yb-countdown]');
    for (var i = 0; i < blocks.length; i++) start(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', init);
})();
